import { FC, ImgHTMLAttributes } from 'react';

export interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  srcVariations?: string[];
}

export const Image: FC<ImageProps> = ({
  src,
  srcVariations: _srcVariations,
  alt,
  loading,
  ...rest
}) => {
  return (
    <img src={src} alt={alt} loading={loading} decoding="async" {...rest} />
  );
};
